import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";
import { SITE_URL } from "../../config/site";
import "./LegalPages.css";

export default function RefundsPage() {
  return (
    <>
      <SEO
        title="Devoluciones y reembolsos | Imalandia"
        description="Consulta la política de devoluciones, incidencias y reembolsos de Imalandia para productos personalizados y pedidos online."
        canonical={`${SITE_URL}/devoluciones`}
      />

      <Header />

      <main className="legal-page">
        <div className="legal-container">
          <p className="legal-eyebrow">DEVOLUCIONES</p>

          <h1>Política de devoluciones y reembolsos</h1>

          <div className="legal-content">
            <p>
              En imalandia.COM queremos que estés completamente satisfecho con
              tu compra. Si por cualquier motivo no es así, este documento
              explica cómo puedes devolver un producto y recuperar tu dinero de
              forma sencilla.
            </p>

            <h3>1. Plazo para devoluciones</h3>

            <p>
              Tienes 10 días naturales desde la fecha de recepción del pedido
              para solicitar una devolución. Una vez transcurrido este plazo, no
              podremos aceptar la solicitud.
            </p>

            <h3>2. Condiciones del producto</h3>

            <p>
              Para que la devolución sea aceptada, el artículo debe cumplir las
              siguientes condiciones:
            </p>

            <p>
              Estar en su estado original, sin usar y sin señales de deterioro.
            </p>

            <p>
              Conservar el embalaje original (caja, bolsa, precinto, etc.) en
              buen estado.
            </p>

            <p>
              Incluir todos los accesorios, manuales o elementos que acompañaban
              al producto.
            </p>

            <p>Llevar la etiqueta o albarán de compra original.</p>

            <p>
              Los productos que lleguen en un estado diferente al descrito
              podrán ser rechazados o sujetos a una depreciación en el
              reembolso.
            </p>

            <h3>3. Productos no retornables</h3>

            <p>
              Por razones de higiene, seguridad o naturaleza del producto, no se
              aceptan devoluciones en los siguientes casos:
            </p>

            <p>Productos personalizados o fabricados a medida.</p>

            <p>
              Artículos sellados que hayan sido abiertos tras la entrega (cuando
              aplique por motivos de higiene).
            </p>

            <p>Productos digitales o licencias activadas.</p>

            <p>
              Artículos en oferta final o marcados expresamente como no
              retornables en su ficha de producto.
            </p>

            <h3>4. Cómo solicitar una devolución</h3>

            <p>El proceso es rápido y completamente online:</p>

            <p>
              Escríbenos a pedidos@imalandia.com con el asunto "Solicitud de
              devolución – Nº de pedido".
            </p>

            <p>
              Indica tu número de pedido, el artículo que deseas devolver y el
              motivo.
            </p>

            <p>
              Nuestro equipo te responderá en un máximo de 2 días hábiles con
              las instrucciones para el envío.
            </p>

            <p>
              Empaqueta el producto de forma segura y envíalo según las
              indicaciones recibidas.
            </p>

            <p>
              No envíes ningún paquete sin haber recibido confirmación previa
              por nuestra parte.
            </p>

            <h3>5. Tiempos y forma del reembolso</h3>

            <p>
              Una vez recibido y revisado el artículo, procesaremos el reembolso
              en un plazo de 5 a 10 días hábiles.
            </p>

            <p>
              El reintegro se realizará por el mismo método de pago utilizado en
              la compra original (tarjeta, PayPal, transferencia, etc.). Los
              tiempos de abono pueden variar según tu entidad bancaria o
              plataforma de pago.
            </p>

            <p>
              Te notificaremos por correo electrónico en el momento en que el
              reembolso haya sido procesado.
            </p>

            <h3>6. Costes de devolución</h3>

            <p>
              Devolución por defecto o error nuestro: Los gastos de envío de
              vuelta corren por nuestra cuenta. Te proporcionaremos una etiqueta
              de devolución prepagada.
            </p>

            <p>
              Devolución por cambio de opinión: Los gastos de envío de retorno
              son responsabilidad del cliente. El importe del reembolso no
              incluirá los costes de envío originales.
            </p>

            <h3>7. Productos dañados o incorrectos</h3>

            <p>
              Si has recibido un producto defectuoso, roto o diferente al que
              pediste, por favor contáctanos en un plazo de 48 horas tras la
              recepción. Adjunta fotografías del artículo y del embalaje.
              Resolveremos el caso con prioridad y sin coste adicional para ti.
            </p>

            <h3>8. Contacto</h3>

            <p>
              Si tienes alguna duda sobre este proceso, estamos aquí para
              ayudarte:
            </p>

            <p>📧 Email: pedidos@imalandia.com</p>

            <p>🕘 Horario de atención: lunes a viernes, de 9:00 a 18:00 h</p>

            <p>Última actualización: abril de 2026</p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
